module.exports = __webpack_public_path__ + "img/skating_2020_001.c1b2f816.jpg";